import { usePathname } from "@/hooks/navigation";
import { createContext, useCallback, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

const WORKSPACE_THEME_KEY = "workspace-theme";

const PaylioContext = createContext();

const PaylioProvider = ({ children }) => {
  const [activeLefMenu, setActiveLefMenu] = useState(true);
  const [getPath, setGetPath] = useState("/");
  const [workspaceTheme, setWorkspaceThemeState] = useState(() => {
    if (typeof window === "undefined") return "dark";
    const stored = window.localStorage.getItem(WORKSPACE_THEME_KEY);
    return stored === "light" || stored === "dark" ? stored : "dark";
  });

  const path = usePathname();

  const isDesktopOrLaptop = useMediaQuery({
    query: "(max-width: 1399px)",
  });

  const setWorkspaceTheme = useCallback((mode) => {
    const next = mode === "light" ? "light" : "dark";
    setWorkspaceThemeState(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(WORKSPACE_THEME_KEY, next);
    }
  }, []);

  const toggleWorkspaceTheme = useCallback(() => {
    setWorkspaceThemeState((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      if (typeof window !== "undefined") {
        window.localStorage.setItem(WORKSPACE_THEME_KEY, next);
      }
      return next;
    });
  }, []);

  useEffect(() => {
    if (isDesktopOrLaptop) {
      setActiveLefMenu(false);
    } else {
      setActiveLefMenu(true);
    }
  }, [isDesktopOrLaptop]);

  useEffect(() => {
    const normalized = path || "/";
    if (normalized === "/" || normalized === "") {
      setGetPath("/");
    } else {
      const seg = normalized.split("/").filter(Boolean)[0];
      setGetPath(seg || "/");
    }
  }, [path]);

  return (
    <PaylioContext.Provider
      value={{
        activeLefMenu,
        setActiveLefMenu,
        getPath,
        workspaceTheme,
        setWorkspaceTheme,
        toggleWorkspaceTheme,
      }}>
      <div className={`workspace-app workspace-theme-${workspaceTheme}`}>
        {children}
      </div>
    </PaylioContext.Provider>
  );
};

export { PaylioContext, PaylioProvider };
